import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-edit-engin',
  templateUrl: './dialog-edit-engin.component.html',
  styleUrls: ['./dialog-edit-engin.component.scss']
})
export class DialogEditEnginComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogEditEnginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
